enum PrinterTransports {
    AUTO = 'auto',
    BLUETOOTH = 'bluetooth',
    USB = 'usb',
}

export default PrinterTransports
